export const COMPONENTS_TO_LAZY_HYDRATE = [
  // 'ABTest',
  'Accordion',
  // 'AdvertiserDisclosure',
  // 'AnchorLink',
  // 'AnchorLinkTarget',
  // 'ApolloIntegrationCanary',
  // 'ArticleHero',
  // 'AuthLink',
  'AutoInsuranceEntryPoint',
  'AutoInsuranceQuotes',
  // 'BackToTopLink',
  'Banner',
  'Button',
  'Calculation',
  'Calculator',
  'CalculatorConditional',
  'CalculatorInput',
  'CalculatorRadio',
  'CalculatorSelect',
  // 'Citation',
  'CitationList',
  // 'Column',
  // 'Columns',
  // 'Container',
  'ContentHeading',
  'ContentImage',
  'ContentQuote',
  'Divider',
  // 'Document',
  'DropCaps',
  'FAQ',
  'FunderaLoanOptionCta',
  'Heading',
  'HlmEntry',
  'HomeInsuranceEntryPoint',
  'HouseAd',
  'Image',
  'Instagram',
  // 'Link',
  'List',
  // 'Li',
  'MarketplaceApplyNow',
  'MarketplaceComparisonLink',
  'MarketplaceComparisonTable',
  'MarketplaceEntityDisplayName',
  'MarketplaceField',
  'MarketplacePartnerPlacement',
  'MarketplaceProductCard',
  'MarketplaceStarRating',
  'MarketplaceRateTable',
  'MarketplaceThirdPartyEmbed',
  'MegaphoneFm',
  'MiniProductCard',
  // 'MoreLink',
  'MortgageLenderInteractiveComparison',
  'NerdTip',
  // 'NoOp',
  'OutOfDateMessage',
  'PostList',
  'PrequalApplicationHouseAd',
  'PrequalBanner',
  'ProductStarRating',
  // 'RenderContextConditional',
  'RentersInsuranceEntryPoint',
  // 'ScreenSizeConditional',
  'SocialMediaLinks',
  'Spotify',
  'StarRating',
  'Table',
  'TableOfContents',
  // 'TableOfContentsTarget',
  'TikTok',
  'Twitter',
  // 'Type',
  // 'UserSegmentConditional',
  'Video',
  'WPCalculator',
  'WPEmbed',
  'WPFeaturedImage',
  'WPHouseAd',
  'WPPostList',
  'WPSocialMediaLinks',
  'WPTable',
  'Well',
];
